export default __webpack_public_path__ + "static/media/ticket-past-due-date.10da1daa.svg";